module.exports = __webpack_public_path__ + "static/media/save-view.b5d817eb.svg";